import React from 'react';
import GatsbyLink from 'gatsby-link';

import Link from '../components/Link';

// import '../css/tags.css';

export default function Tags({ pathContext }) {
  const { posts, post, tag } = pathContext;
  if (tag) {
    return (
      <div>
        <h1>
          {post.length} пост{post.length === 1 ? '' : 'а'} с тегом {tag}
        </h1>
        <div>
          {post.map(({ id, frontmatter, excerpt }) => {
            return (
              <article key={id} className="post-preview">
                <header className="post-preview__header">
                  <Link to={frontmatter.path}>
                    <h2>{frontmatter.title}</h2>
                  </Link>
                </header>
                <section>
                  <p>{excerpt}</p>
                </section>
              </article>
            );
          })}
        </div>
        <Link to="/tags">
          Все теги
        </Link>
      </div>
    );
  }
  return (
    <div>
      <h1>Теги</h1>
      <ul className="tags">
        {Object.keys(posts).map(tagName => {
          const tags = posts[tagName];
          return (
            <li key={tagName}>
              <GatsbyLink to={`/tags/${tagName}`}>
                {tagName}
              </GatsbyLink>
            </li>
          );
        })}
      </ul>
      <Link to="/">
        Все посты
      </Link>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/templates/tags.js